import './ListOrders.css';
import React from 'react';
import Header from '../components/Header';
import { useState, useEffect } from 'react';
import OrderListItem from '../components/OrderListItem';
import Button from '../components/Button';
import { Link } from 'react-router-dom';

function ListOrders() {

    useEffect(() => {
        function getActiveOrders() {
            fetch(`${process.env.REACT_APP_API_URL}/orders/active`,{
                withCredentials: true,
                credentials: 'include',
            })
                .then(response => {
                    if (!response.ok) {
                        setFetchError(response.status);
                        throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
                })
                .then(data => {
                    let newData = []
                    for (const item of data) {
                        console.log(item)
                        let itemCopy = item;
                        if (item.status === 'todo') {
                            itemCopy.displayStatus = 'To Do';
                        } else if (item.status === 'inprogress') {
                            itemCopy.displayStatus = 'In Progress';
                        } else if (item.status === 'finished') {
                            itemCopy.displayStatus = 'Finished';
                        }
                        newData.push(itemCopy);
                    }
                    setOrderList(newData);
                })
                .catch(err => {
                    setFetchError(500);
                    console.log(err);
                });
        }
        getActiveOrders();
        const interval = setInterval(() => getActiveOrders(), 10000)
        return () => {
            clearInterval(interval);
          }
    }, [])

    const [orderList, setOrderList] = useState([]);
    const [fetchError, setFetchError] = useState(0);

    async function changeOrderStatus(id, status, displayStatus) {
        let order = orderList.filter(i => i.orderId === id)[0];
        let otherOrders = orderList.filter(i => i.orderId !== id);
        order.status = status;
        order.displayStatus = displayStatus;
        setOrderList([...otherOrders, order]);

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/orders/status/${order.orderId}`, {
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({status: status}),
              withCredentials: true,
              credentials: 'include',
            });
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
          
            const jsonResponse = await response.json();
            console.log('POST request successful:', jsonResponse);
        } catch (error) {
            console.error('POST request failed:', error);
        }
    }


    return (
        <div className='main-list-order-div'>
            <Header />
            <h2 className='current-orders-header'>Current Orders</h2>
            <div className='order-list'>
                {
                    orderList.length > 0 ? orderList.sort((a, b) => (a.status < b.status) ? 1 : -1).map(item => 
                        <OrderListItem key={item.orderId} order={item} changeOrderStatus={(id, status, displayStatus) => changeOrderStatus(id, status, displayStatus)}/>)
                        : fetchError === 0 ? <h3>Loading orders...</h3> : <h4 style={{color: 'red'}}>Error fetching orders</h4>
                }
            </div>
            <div className='list-orders-home-button'>
                <Link to='/home'>
                    <Button buttonText='Home'/>
                </Link>
            </div>
        </div>
    )
}

export default ListOrders;